import { render, staticRenderFns } from "./follow-task.vue?vue&type=template&id=6c1cca11&"
import script from "./follow-task.vue?vue&type=script&lang=js&"
export * from "./follow-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports